import React from 'react';
export function ProblemSection() {
  return <section className="w-full py-16 px-4 bg-white" data-id="element-62">
      <div className="max-w-2xl mx-auto font-body text-lg md:text-xl text-brown leading-relaxed space-y-8" data-id="element-63">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-center text-brown mb-8" data-id="element-64">
          Sé exactamente cómo te sentís.
        </h2>

        <p data-id="element-65">
          Hacés "todo bien": comés ensalada, comprás los productos "fit" que ves
          en el súper, tomás agua... pero la sensación de pesadez no se va.
        </p>

        <p data-id="element-66">
          Llegás a las 8 de la noche con la panza dura, hinchada como si
          estuvieras embarazada de 6 meses, y con un nivel de agotamiento que no
          se te pasa ni durmiendo 10 horas seguidas.
        </p>

        <div className="p-6 bg-cream border-l-4 border-terracotta italic text-brown-light" data-id="element-67">
          Te dijeron que "es el estrés", que "es la edad" o que "en Argentina es
          imposible vivir tranquila". Pero no es tu culpa.
        </div>
      </div>
    </section>;
}